import { SVGProps } from "react";

const ArrowIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.8226 8.67146H1.78327C1.13265 8.67146 0.605469 8.14433 0.605469 7.49378C0.605469 6.84323 1.13265 6.3161 1.78327 6.3161H15.8226C16.4733 6.3161 17.0004 6.84323 17.0004 7.49378C17.0004 8.14433 16.4733 8.67146 15.8226 8.67146Z" />
      <path d="M7.18414 14.2415C6.8977 14.2415 6.61032 14.1374 6.38371 13.9273L0.376926 8.35691C0.13477 8.1322 -0.00232574 7.81612 2.98637e-05 7.48542C0.00238546 7.1552 0.14325 6.84053 0.388704 6.61912L6.56038 1.04869C7.04328 0.612952 7.78812 0.651108 8.2239 1.13396C8.65969 1.61681 8.62153 2.36157 8.13863 2.79731L2.92239 7.50521L7.98552 12.2004C8.46229 12.6427 8.49056 13.388 8.04817 13.8647C7.81591 14.1148 7.50073 14.2415 7.18414 14.2415Z" />
    </svg>
  );
};

export default ArrowIcon;
